// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='options-cm'] {\r\n  cursor: pointer;\r\n  color: var(--primary-font-color);\r\n  font-size: 14px;\r\n}\r\n\r\n  [name='options-cm'] .options {\r\n    padding: 6px 15px;\r\n  }\r\n\r\n  [name='options-cm'] .options:hover {\r\n    background: var(--primary-background);\r\n    /* color: var(--header-basic-font); */\r\n  }\r\n\r\n  [name='options-cm'] .options>img {\r\n    width: 16px;\r\n    height: 16px;\r\n    margin-bottom: 2px;\r\n    margin-right: 7px;\r\n  }", ""]);
// Exports
module.exports = exports;
